import PackageImporter from './PackageImporter';

angular.module('sfx.import', []).service('packageImporter', PackageImporter);
